import React, { useState, Fragment, useEffect } from "react";

//* import css
import cssClasses from "./Hierarchy.module.css";

//REDUX
import action from "../../Redux Store/actions";

import { useDispatch } from "react-redux";
import Hierarchy from "../Users/CreateUser/Hierarchy"
import { Box, Typography } from "@mui/material";

function Hierarchys({}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(action.activeMenu("hierarchy"));
  }, []);

  return (
    <>
      <div className={cssClasses.wrapperPage}>
        <Box className={cssClasses.headerWrapper}>
          <Box className={cssClasses.headerLeftSide}>
            <Box display={'flex'} flexDirection={'column'} gap={'1rem'}>
              <Typography className={cssClasses.headerTittle}>
                Hierarchy
              </Typography>
            </Box>
          </Box>
        </Box>
        <div className={cssClasses.mainWrapper}>
    <Hierarchy isAssignRoleAvailable={false} />
    </div>
    </div>
    </>
  )
}

export default Hierarchys;